import styled from '@emotion/styled';
import axios from 'axios';
import Checkbox from 'components/ui/CheckBox';
import CustomModal from 'components/ui/CustomModal';
import { ButtonWrapper, CancelButton, SaveButton } from 'components/ui/Rules/Components/RuleStyledComponents';
import colors from 'css/colors';
import React, { useContext, useState } from 'react';
import Select from 'react-select';
import { Button, Dropdown, Form, Input, Modal } from 'semantic-ui-react';
import { UserEntity } from './types';
import { UserContext } from '../../UserContext';
import produce from 'immer';

interface IError {
  assignee: boolean;
  startDate: boolean;
  endDate: boolean;
}

interface Proptypes {
  onClose: () => void;
  users: UserEntity[];
  user: UserEntity;
  setRerender: (value: boolean) => void;
}

export const Header = styled.div`
  font-weight: 700;
  font-size: 20px;
`;

export const Content = styled.div`
  margin-top: 48px;
`;

const Error = styled.div`
  color: ${colors.red};
`;

const VacationModal = (props: Proptypes) => {
  const [assignee, setAssignee] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [addToReport, setAddToReport] = useState(true);
  const [errors, setErrors] = useState<IError>({
    assignee: false,
    startDate: false,
    endDate: false,
  });
  const { user } = useContext(UserContext) as any;

  const hasErrors = () => {
    var today = new Date();
    const newErrors = produce(errors, draft => {
      draft.assignee = assignee == null;
      draft.startDate = startDate == null;
      draft.endDate = endDate != null && new Date(endDate) < today;
    });
    setErrors(newErrors);
    return newErrors.assignee || newErrors.startDate || newErrors.endDate;
  };

  const handleSave = async () => {
    const foundErrors = hasErrors();
    if (!foundErrors) {
      const vacationDetails = {
        employeeId: props.user.id,
        coveringEmployeeId: assignee.value,
        addToReport,
        startDate,
        endDate,
        addedByUserId: user.id,
      };
      await axios.post('/api/users/updateVacationStatus', { VacationUser: vacationDetails });
      props.onClose();
      props.setRerender(true);
    }
  };
  return (
    <CustomModal
      onClose={() => {
        props.onClose();
      }}
      open={true}
      notCloseOverlay={true}
      moreStyles={{ height: 530 }}
    >
      <Header>Replace User</Header>
      <Content>
        <span>Searches assigned to this user replace with</span>
        <div style={{ marginBottom: 8, marginTop: 8 }}>
          <Select
            options={props.users.map(u => {
              return { label: `${u.firstName} ${u.lastName}`, value: u.id };
            })}
            onChange={(selection: any) => {
              setAssignee(selection);
            }}
            value={assignee}
            placeholder={`Select...`}
            isClearable={true}
            isMulti={false}
            maxMenuHeight={150}
          />
        </div>
        {errors.assignee && <Error>Assignee is required</Error>}
        <div style={{ marginTop: 32, display: 'flex' }}>
          {/* <Checkbox checked={addToReport} onCheckChanged={() => setAddToReport(!addToReport)} /> */}
          <span style={{ color: '#8E8E93', marginLeft: 8 }}>
            Searches will display on the replacement users Assigned User Report
          </span>
        </div>
        <div style={{ marginTop: 12 }}>
          <Form>
            <Input
              type="date"
              label="Start Date"
              format="MM/DD/YYYY"
              value={startDate}
              onChange={(e: any, x: any) => {
                if (x?.value) {
                  setStartDate(x.value);
                }
              }}
            />
            {errors.startDate && <Error>Start Date is required</Error>}
            <Input
              style={{ marginTop: 10 }}
              type="date"
              label="End Date"
              format="MM/DD/YYYY"
              value={endDate}
              width={50}
              onChange={(e: any, x: any) => {
                if (x?.value) {
                  setEndDate(x.value);
                }
              }}
            />
            {errors.endDate && <Error>End Date must be a future date</Error>}
          </Form>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            borderTop: '1px solid #e5e5ea',
            marginTop: 40,
            paddingTop: 24,
          }}
        >
          <CancelButton onClick={() => props.onClose()}>Cancel</CancelButton>
          <SaveButton
            onClick={() => handleSave()}
            backgroundColor={colors.redLight}
            style={{ marginLeft: 8 }}
          >
            Save
          </SaveButton>
        </div>
      </Content>
    </CustomModal>
  );
};
export default VacationModal;
